import React, { useEffect, useState } from 'react';
import Modal from '@/components/ui-bridge/core/Modal';
import arrowLeftImg from '@/images/arrow-left.svg';
import arrowRightImg from '@/images/arrow-right.svg';
import classes from '@/components/InfoStepModal/InfoStepModal.module.css';
import { FormattedMessage } from 'react-intl';

const InfoStepModal = ({ title, steps, textNextImg, isOpen, onClose, onConfirm }) => {
  const [activeStep, setActiveStep] = useState(0);
  const maxSteps = steps.length;
  const handleNextStep = () => {
    setActiveStep(activeStep + 1);
  };
  const handlePrevStep = () => {
    setActiveStep(activeStep - 1);
  };
  const handleDotStep = step => {
    setActiveStep(step);
  };
  useEffect(() => {
    setActiveStep(0);
  }, [isOpen]);
  return (
    <Modal open={isOpen} onClose={onClose} className={classes.infoStepModal}>
      <div className={classes.modal}>
        <div className={classes.head}>{title}</div>
        <div className={classes.body}>
          <p>{steps[activeStep].text}</p>
          <div className={classes.imageContainer}>
            <div className={classes.stepsContainer}>
              {activeStep > 0 && <img src={arrowLeftImg} className={classes.step} onClick={() => handlePrevStep()} />}
            </div>
            <img src={steps[activeStep].imgPath} alt={steps[activeStep].label} className={classes.img} />
            <div className={classes.stepsContainer}>
              {activeStep + 1 < maxSteps && (
                <img src={arrowRightImg} className={classes.step} onClick={() => handleNextStep()} />
              )}
            </div>
          </div>
          <div className={classes.dotContainer}>
            <div>{textNextImg}</div>

            <div className={classes.area}>
              {steps.map((t, i) => {
                return (
                  <div
                    className={`${classes.dot} ${activeStep === i && classes.active}`}
                    key={i}
                    onClick={() => handleDotStep(i)}
                  ></div>
                );
              })}
            </div>
          </div>

          <div className={classes.buttonContainer}>
            <button className={classes.close} onClick={() => onClose()}>
              <FormattedMessage id="CLOSE" />
            </button>
            <button className={classes.confirm} onClick={() => onConfirm()}>
              <FormattedMessage id="SHOW_PLANS" />
            </button>
          </div>
        </div>

        <div className={classes.footer}></div>
      </div>
    </Modal>
  );
};

export default InfoStepModal;
